import GiftWrap from './GiftWrap';

export default GiftWrap;
